import apiService from './api';

const diseaseService = {
  async getDiseases(params = {}) {
    return apiService.get('/diseases', { params });
  },

  async createDisease(payload) {
    return apiService.post('/diseases', payload);
  },

  async updateDisease(id, payload) {
    return apiService.put(`/diseases/${id}`, payload);
  },

  async deleteDisease(id) {
    return apiService.delete(`/diseases/${id}`);
  },

  async importDiseases(items) {
    return apiService.post('/diseases/import', { items });
  }
};

export default diseaseService;

